import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_a9cc0a93-1f4d-4a5a-adee-0b6b5c9eedbf/artifacts/fb6ipjk0_Prancheta%2038.png";
const WHATSAPP_URL = "https://wa.me/556193761185?text=Ol%C3%A1!%20Vim%20pelo%20site%20e%20gostaria%20de%20um%20or%C3%A7amento.";

const NAV_ITEMS = [
  { label: "Sobre", href: "#sobre" },
  { label: "Serviços", href: "#servicos" },
  { label: "Galeria", href: "#galeria" },
  { label: "Depoimentos", href: "#depoimentos" },
  { label: "Contato", href: "#contato" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "py-2 shadow-lg shadow-black/20" : "py-3"
      }`}
      style={{ backgroundColor: "#00929A" }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" data-testid="header-logo" className="flex items-center">
          <img
            src={LOGO_URL}
            alt="Amine Festas"
            className="h-[7rem] md:h-28 logo-invert transition-all duration-500"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="text-sm font-medium tracking-wide transition-colors duration-300 text-white/80 hover:text-[#E4077B]"
            >
              {item.label}
            </a>
          ))}
          <Link
            to="/servicos"
            className="text-sm font-medium tracking-wide transition-colors duration-300 text-white/80 hover:text-[#E4077B]"
          >
            Blog
          </Link>
        </nav>

        {/* CTA Button */}
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="header-whatsapp-btn"
          className="hidden md:inline-flex items-center gap-2 bg-[#E4077B] hover:bg-[#c8066a] text-white text-sm font-medium px-6 py-2.5 rounded-full transition-all duration-300 hover:shadow-lg hover:shadow-[#E4077B]/20"
        >
          Falar com Amine
        </a>

        {/* Mobile Menu Toggle */}
        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden p-2 rounded-xl transition-colors text-white"
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <>
          <div
            className="md:hidden fixed inset-0 bg-black/30 z-40"
            onClick={() => setMenuOpen(false)}
          />
          <div
            data-testid="mobile-menu"
            className="md:hidden absolute top-full left-0 right-0 z-50 py-6 px-6 animate-fade-in border-t border-white/10"
            style={{ backgroundColor: "#00929A" }}
          >
          <nav className="flex flex-col gap-4">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="text-white/80 text-base font-medium py-2 border-b border-white/10"
              >
                {item.label}
              </a>
            ))}
            <Link
              to="/servicos"
              onClick={() => setMenuOpen(false)}
              className="text-white/80 text-base font-medium py-2 border-b border-white/10"
            >
              Blog
            </Link>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 inline-flex items-center justify-center gap-2 bg-[#E4077B] text-white text-sm font-medium px-6 py-3 rounded-full"
            >
              Falar com Amine
            </a>
          </nav>
        </div>
        </>
      )}
    </header>
  );
}
